import { Action, createReducer, on } from '@ngrx/store';
import { MileagePlanProfileLookupStatus } from '../../../dtos/response/mileage-plan-profile-lookup-response/mileage-plan-profile-lookup-status';
import { Status } from '../../../models/status';
import {
  initializeMileagePlanLookupByPaxServiceState,
  mileagePlanAutoFillProfileSearch,
  mileagePlanProfileSearchByPassenger,
  mileagePlanProfileSearchByPaxComplete,
} from './mileage-plan-lookup-by-pax-service.actions';
import { initialMileagePlanLookupByPaxServiceState, mileagePlanLookupByPaxAdapter } from './mileage-plan-lookup-by-pax-service.state';

function createLoadingMileagePlanLookupEntity(mileagePlanNumber: string, passengerHashId: string, autoFillOnLookup: boolean) {
  return {
    passengerHashId,
    mileagePlanNumber,
    accountLookupResponse: null,
    memberInfoLookupResponse: null,
    mileagePlanProfileLookupCRUDStatus: Status.LOADING,
    mileagePlanProfileLookupStatus: null,
    mileagePlanProfileLookupError: null,
    autoFillOnLookup,
  };
}

const featureReducer = createReducer(
  initialMileagePlanLookupByPaxServiceState,

  /**
   * Set the state to the initial value defined in the mileage-plan-lookup-by-pax-service.state file
   */
  on(initializeMileagePlanLookupByPaxServiceState, (state) => ({ ...state, ...initialMileagePlanLookupByPaxServiceState })),

  on(mileagePlanAutoFillProfileSearch, (state, { mileagePlanNumber, passengerHashId }) => {
    return {
      ...state,
      mileagePlanLookupByPaxResponse: mileagePlanLookupByPaxAdapter.setOne(
        createLoadingMileagePlanLookupEntity(mileagePlanNumber, passengerHashId, true),
        state.mileagePlanLookupByPaxResponse
      ),
    };
  }),
  on(mileagePlanProfileSearchByPassenger, (state, { mileagePlanNumber, passengerHashId }) => {
    return {
      ...state,
      mileagePlanLookupByPaxResponse: mileagePlanLookupByPaxAdapter.setOne(
        createLoadingMileagePlanLookupEntity(mileagePlanNumber, passengerHashId, false),
        state.mileagePlanLookupByPaxResponse
      ),
    };
  }),
  /**
   * Completes the mileagePlanLookup request for MP lookup by pax to the API
   */
  on(mileagePlanProfileSearchByPaxComplete, (state, { response, passengerHashId, autoFillOnLookup }) => {
    return {
      ...state,
      mileagePlanLookupByPaxResponse: mileagePlanLookupByPaxAdapter.setOne(
        {
          passengerHashId,
          mileagePlanNumber: response?.response?.mileagePlanNumber ?? null,
          accountLookupResponse: response?.response?.accountLookupResponse ?? null,
          memberInfoLookupResponse: response?.response?.memberInfoLookupResponse ?? null,
          mileagePlanProfileLookupCRUDStatus: Status.STABLE,
          mileagePlanProfileLookupStatus: response?.status ?? MileagePlanProfileLookupStatus.UNCAUGHT,
          mileagePlanProfileLookupError: response?.error ?? null,
          autoFillOnLookup,
        },
        state.mileagePlanLookupByPaxResponse
      ),
    };
  })
);

export function mileagePlanLookupByPaxServiceReducer(state = initialMileagePlanLookupByPaxServiceState, action: Action) {
  return featureReducer(state, action);
}
